import { TextDescriptor } from "../Models/Common/TextDescriptor";
import { LocalizationObject } from "../Models/Common/LocalizationObject";

/**
 * Extracts the LocalizationObject from a TextDescriptor
 * Handles backward compatibility if a string is passed instead
 */
export const getLocalizationFromDescriptor = (descriptor: TextDescriptor | string | undefined, defaultLocalization: LocalizationObject = { type: 'Literal', text: '' }): LocalizationObject => {
    if (!descriptor) {
        return defaultLocalization;
    }
    
    if (typeof descriptor === 'string') {
        // Backward compatibility: convert string to LocalizationObject
        return { type: 'Literal', text: descriptor };
    }
    
    return descriptor.localizationObject;
};

/**
 * Gets the text from a TextDescriptor 
 * For now, only handles Literal type until localization provider is integrated
 */
export const getTextFromDescriptor = (
    descriptor: TextDescriptor | string | undefined,
    defaultText: string = ''
): string => {
    if (!descriptor) {
        return defaultText;
    }
    
    if (typeof descriptor === 'string') {
        // Backward compatibility: return string directly
        return descriptor;
    }
    
    // For now, only handle Literal type
    // TODO: Integrate with localization provider for Localized and Internal types
    if (descriptor.localizationObject.type === 'Literal') {
        return descriptor.localizationObject.text;
    }
    
    // Fallback for Localized/Internal types until provider is integrated
    return descriptor.localizationObject.text || defaultText;
};

/**
 * Extracts styling properties from a TextDescriptor
 */
export const getStyleFromDescriptor = (descriptor: TextDescriptor | string | undefined) => {
    if (!descriptor || typeof descriptor === 'string') {
        return {};
    }
    
    const style: any = {};
    
    if (descriptor.color) style.color = descriptor.color;
    if (descriptor.fontSize) style.fontSize = descriptor.fontSize;
    if (descriptor.fontWeight) style.fontWeight = descriptor.fontWeight;
    if (descriptor.fontStyle) style.fontStyle = descriptor.fontStyle;
    if (descriptor.textDecoration) style.textDecoration = descriptor.textDecoration;
    
    return style;
};
